/** Token bridge for the reschedule dialog's preview panel: neutral text, warning and error tones, no brand colour. */
import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;
export const visitMovePreviewStyleId = 'visit-move-preview-theme';
export const visitMovePreviewBridgeStyles = {
  'wb-visit-move-preview': {
    '--local-visit-move-preview-gap': tokens.spacing.sm,
    '--local-visit-move-preview-padding': tokens.spacing.lg,
    '--local-visit-move-preview-radius': tokens.radius.md,
    '--local-visit-move-preview-border': tokens.color.border.secondary,
    '--local-visit-move-preview-background': tokens.color.background.secondary,
    '--local-visit-move-preview-font-size': tokens.font.size.textSm,
    '--local-visit-move-preview-text': tokens.color.text.secondary,
    '--local-visit-move-preview-strong': tokens.color.text.primary,
    '--local-visit-move-preview-strong-weight': tokens.font.weight.semibold,
    '--local-visit-move-preview-muted': tokens.color.text.tertiary,
    '--local-visit-move-preview-warning': tokens.color.text.warningPrimary,
    '--local-visit-move-preview-error': tokens.color.text.errorPrimary,
  },
};
